import { $deleteFromArray, $handleError, $updateOrAdd } from '@/utils';
import apiService from '@Task/service/task-comments.service';
import Vue from 'vue';

export const TASK_COMMENTS = {
  namespaced: true,
  state: {
    entries: [],
    total: 0,
    loading: false,
    updateLoading: false,
    options: {
      itemsPerPage:50,
      sortDesc:true
    },
  },
  getters: {
    GET_ENTRIES(state) {
      return state.entries;
    },
    GET_TOTAL(state) {
      return state.total;
    },
    GET_LOADING(state) {
      return state.loading;
    },
    GET_UPDATE_LOADING(state) {
      return state.updateLoading;
    },
    GET_OPTIONS(state) {
      return state.options;
    },
  },
  mutations: {
    SET_ENTRIES(state, value) {
      state.entries = value;
    },
    SET_TOTAL(state, value) {
      state.total = value;
    },
    SET_LOADING(state, value) {
      state.loading = value;
    },

    SET_UPDATE_LOADING(state, value) {
      state.updateLoading = value;
    },

    SET_OPTIONS(state, value) {
      state.options = value;
    },
  },
  actions: {
    GET({ commit, state },taskId) {
      commit('SET_LOADING', true);
      return apiService
        .get(taskId,state.options)
        .then((res) => {
          commit('SET_ENTRIES', res.data.items);
          commit('SET_TOTAL', res.data.total);
        })
        .catch((err) => {
          $handleError(err);
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    },

    GET_BY_ID(context, id) {
      return apiService.getById(id);
    },
    UPDATE({ state, commit }, data) {
      return new Promise((resolve, reject) => {
        commit('SET_UPDATE_LOADING', true);

        return apiService
          .update(data)
          .then((res) => {
            $updateOrAdd(state.entries, res.data,'id',true);
            Vue.prototype.$dialog.notify.success(
              `Comment Successfully ${data.id ? 'Updated' : 'Added'}.`,
            );
            if (!data.id) {
              commit('SET_TOTAL', ++state.total);
            }
            commit('SET_UPDATE_LOADING', false);
            resolve(res.data);
          })
          .catch((err) => {
            $updateOrAdd(state.entries, data);
            commit('SET_TOTAL', ++state.total);
            commit('SET_UPDATE_LOADING', false);
            $handleError(err);
            reject(err);
          })
          .finally(() => {
          
            commit('SET_UPDATE_LOADING', false);
          });


      });
    
    },
    DELETE({ state, commit }, id) {
      return apiService
        .del(id)
        .then(() => {
          $deleteFromArray(state.entries, id);
          commit('SET_TOTAL', --state.total);
          Vue.prototype.$dialog.notify.success('Deleted Successfully', {
            position: 'top-right',
            timeout: 3000,
          });
        })
        .catch((err) => {
          $handleError(err);
        });
    },
  },
};
